import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { stickyLabel } from '../data/content';
import { handleScrollClick } from './CtaButton';
export function StickyCta() {
  const [pastHero, setPastHero] = useState(false);
  const [offerVisible, setOfferVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('hero');
    const offer = document.getElementById('offer');
    if (typeof IntersectionObserver === 'undefined') return;
    const heroObs = new IntersectionObserver(([entry]) => {
      setPastHero(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    });
    const offerObs = new IntersectionObserver(([entry]) => setOfferVisible(entry.isIntersecting));
    if (hero) heroObs.observe(hero);
    if (offer) offerObs.observe(offer);
    return () => {
      heroObs.disconnect();
      offerObs.disconnect();
    };
  }, []);
  const visible = pastHero && !offerVisible;
  return <AnimatePresence data-id="element-269" data-mp="75vt9ghykvbc">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-50 border-t border-hair bg-white/95 px-4 pt-3 backdrop-blur md:hidden" style={{
      paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))'
    }} initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-270" data-mp="76np8sfgwv25">
          <a href="#offer" onClick={handleScrollClick} data-cta="offer" className="flex min-h-[56px] w-full items-center justify-center whitespace-nowrap rounded-xl bg-cta font-display text-[15px] font-black tracking-[0.02em] text-cta-ink shadow-cta transition-[background-color,transform] duration-150 ease-out hover:bg-cta-hover active:translate-y-[2px]" data-id="element-271" data-mp="pvc16ovz3q1s">
            {stickyLabel}
          </a>
        </motion.div>}
    </AnimatePresence>;
}